import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["connected", "stepIconBorderColor", "stepIconColor", "horizontalLineMargin", "horizontalStepPadding", "iconDisplay", "iconSize", "orientation", "stepColor", "stepFontSize", "stepLineHeight", "stepperPosition", "steps", "sx", "textAlignment", "verticalLineHeight", "verticalLineMargin", "verticalLinePadding"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState } from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { StepConnector } from '@mui/material';
import Box from '@mui/material/Box';
import TAGLink from '../TAGLink/TAGLink';
import Modal from '../../templates/Modal/Modal';

var TAGAgendaStepper = function TAGAgendaStepper(_ref) {
  var _ref$connected = _ref.connected,
      connected = _ref$connected === void 0 ? false : _ref$connected,
      _ref$stepIconBorderCo = _ref.stepIconBorderColor,
      stepIconBorderColor = _ref$stepIconBorderCo === void 0 ? undefined : _ref$stepIconBorderCo,
      _ref$stepIconColor = _ref.stepIconColor,
      stepIconColor = _ref$stepIconColor === void 0 ? 'secondary.main' : _ref$stepIconColor,
      _ref$horizontalLineMa = _ref.horizontalLineMargin,
      horizontalLineMargin = _ref$horizontalLineMa === void 0 ? 7.5 : _ref$horizontalLineMa,
      _ref$horizontalStepPa = _ref.horizontalStepPadding,
      horizontalStepPadding = _ref$horizontalStepPa === void 0 ? '14px' : _ref$horizontalStepPa,
      _ref$iconDisplay = _ref.iconDisplay,
      iconDisplay = _ref$iconDisplay === void 0 ? true : _ref$iconDisplay,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 16 : _ref$iconSize,
      _ref$orientation = _ref.orientation,
      orientation = _ref$orientation === void 0 ? 'horizontal' : _ref$orientation,
      _ref$stepColor = _ref.stepColor,
      stepColor = _ref$stepColor === void 0 ? 'secondary.main' : _ref$stepColor,
      _ref$stepFontSize = _ref.stepFontSize,
      stepFontSize = _ref$stepFontSize === void 0 ? '16px' : _ref$stepFontSize,
      stepLineHeight = _ref.stepLineHeight,
      _ref$stepperPosition = _ref.stepperPosition,
      stepperPosition = _ref$stepperPosition === void 0 ? 'center' : _ref$stepperPosition,
      steps = _ref.steps,
      sx = _ref.sx,
      _ref$textAlignment = _ref.textAlignment,
      textAlignment = _ref$textAlignment === void 0 ? 'center' : _ref$textAlignment,
      _ref$verticalLineHeig = _ref.verticalLineHeight,
      verticalLineHeight = _ref$verticalLineHeig === void 0 ? 24 : _ref$verticalLineHeig,
      _ref$verticalLineMarg = _ref.verticalLineMargin,
      verticalLineMargin = _ref$verticalLineMarg === void 0 ? 8 : _ref$verticalLineMarg,
      verticalLinePadding = _ref.verticalLinePadding,
      props = _objectWithoutProperties(_ref, _excluded);

  var CONNECTOR_STYLE = {
    borderBottom: 'none',
    borderTop: '1px solid',
    borderTopColor: 'neutrals.primary',
    width: orientation === 'vertical' ? 'fit-content' : '100%',
    borderRadius: '1px'
  };
  var VERTICAL_NOT_CONNECTED = {
    '&	.MuiStepConnector-lineVertical': [{
      height: verticalLineHeight
    }, CONNECTOR_STYLE]
  };
  var VERTICAL_CONNECTED = {
    '&	.MuiStepConnector-lineVertical': [{
      minHeight: '35px',
      height: verticalLineHeight,
      marginTop: '-18px',
      marginBottom: '-22px'
    }, CONNECTOR_STYLE]
  };
  var HORIZONTAL_CONNECT = {
    left: 'calc(-50%)',
    right: 'calc(50%)'
  };
  var HORIZONTAL_DISCONNECT = {
    left: 'calc(-50% + 12px)',
    right: 'calc(50% + 12px)'
  };
  var connectedStyle = connected ? {
    connectedVertical: VERTICAL_CONNECTED,
    connectedHorizontal: HORIZONTAL_CONNECT,
    verticalPadding: '',
    vLPadding: ''
  } : {
    connectedVertical: VERTICAL_NOT_CONNECTED,
    connectedHorizontal: HORIZONTAL_DISCONNECT,
    verticalPadding: '0px',
    vLPadding: verticalLinePadding
  };
  var NO_ICON = {
    display: 'flex',
    alignItems: 'center'
  };
  var orientationStyle = orientation === 'horizontal' ? {
    alternativeLabel: true,
    hideIcon: {},
    textPosition: {
      display: 'flex',
      justifyContent: 'center'
    },
    fontSize: stepFontSize,
    lineHeight: stepLineHeight
  } : {
    alternativeLabel: false,
    hideIcon: !iconDisplay && NO_ICON,
    textPosition: {},
    fontSize: '18px',
    lineHeight: ''
  };
  var connector = React.createElement(StepConnector, {
    sx: [{
      '&.MuiStepConnector-horizontal': [{
        top: horizontalLineMargin
      }, connectedStyle.connectedHorizontal],
      '.MuiStepConnector-lineHorizontal': _objectSpread({}, CONNECTOR_STYLE),
      '&.MuiStepConnector-vertical': {
        marginLeft: "".concat(verticalLineMargin, "px"),
        py: "".concat(connectedStyle.vLPadding, "px")
      }
    }, connectedStyle.connectedVertical, sx]
  });
  var DOT_BORDER = stepIconBorderColor && {
    boxSizing: 'border-box',
    borderRadius: '50%',
    border: '3px solid',
    borderColor: stepIconBorderColor
  };
  var TEXT_ALIGN_LEFT = textAlignment === 'left' && {
    textAlign: 'left',
    position: 'relative',
    left: '55px'
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      stepIndex = _useState4[0],
      setStepIndex = _useState4[1];

  return React.createElement(React.Fragment, null, React.createElement(Modal, {
    arrows: true,
    open: open,
    currentStep: stepIndex,
    onOpen: function onOpen() {
      return setOpen(true);
    },
    onClose: function onClose() {
      return setOpen(false);
    },
    steps: steps,
    sx: {
      '.MuiDialog-paper': {
        width: '620px',
        maxHeight: '500px',
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'space-between'
      },
      '#DrawerContent': {
        overflow: 'unset'
      },
      '.MuiDialogActions-root': {
        p: '15px'
      },
      '.MuiDrawer-paper': {
        borderRadius: '16px 16px 0px 0px',
        maxHeight: '500px',
        minHeight: '500px'
      }
    }
  }), React.createElement(Box, {
    sx: [{
      display: 'flex',
      justifyContent: stepperPosition
    }, sx]
  }, React.createElement(Stepper, _objectSpread(_objectSpread({}, props), {}, {
    connector: connector,
    orientation: orientation,
    alternativeLabel: orientationStyle.alternativeLabel,
    sx: [orientationStyle.hideIcon]
  }), steps.map(function (label, index) {
    return React.createElement(Step, {
      key: index,
      active: true,
      sx: {
        '&.MuiStep-horizontal': {
          px: horizontalStepPadding
        }
      }
    }, React.createElement(StepLabel, {
      sx: {
        '.MuiStepLabel-labelContainer ': orientationStyle.textPosition,
        '.MuiStepLabel-labelContainer > .MuiStepLabel-label': _objectSpread({}, TEXT_ALIGN_LEFT),
        '&.MuiStepLabel-horizontal > .MuiStepLabel-labelContainer > .MuiStepLabel-label': {
          width: '75%'
        },
        '&.MuiStepLabel-vertical > .MuiStepLabel-labelContainer > .MuiStepLabel-label': {
          width: '100%'
        },
        '&.MuiStepLabel-vertical': {
          padding: connectedStyle.verticalPadding
        },
        '&.MuiStepLabel-vertical .MuiStepLabel-iconContainer': {
          display: iconDisplay ? 'flex' : 'none',
          paddingRight: '20px'
        },
        '.MuiStepIcon-text': {
          display: 'none'
        },
        '.MuiSvgIcon-root': {
          fontSize: iconSize < 8 ? 8 : iconSize,
          zIndex: '1',
          '&.Mui-active': _objectSpread({
            color: stepIconColor
          }, DOT_BORDER)
        }
      }
    }, React.createElement(TAGLink, {
      variant: "captionLargeRegular",
      color: stepColor,
      onClick: function onClick(event) {
        event.preventDefault();
        setStepIndex(index);
        setOpen(true);
      },
      sx: {
        fontSize: orientationStyle.fontSize,
        lineHeight: orientationStyle.lineHeight
      }
    }, "".concat(label.headlineText))));
  }))));
};

export default TAGAgendaStepper;